var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-3"},[_c('button',{staticClass:"btn btn-success",on:{"click":function($event){return _vm.$emit('open-modal')}}},[_vm._v("\n        + "+_vm._s(_vm.$t('add_income_category'))+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }